module.exports = __webpack_public_path__ + "static/media/j0n.823d18b8.svg";